import React, { useState, useEffect } from "react";
import emimaru_flying from "../assets/images/emimaru_flying.png";

export default function ScrollToTop() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShow(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!show) return null;

    return (
        <button
            onClick={handleClick}
            className="fixed bottom-8 right-8 w-16 h-16 md:w-20 md:h-20 z-50 flex flex-col items-center justify-end hover:scale-110 transition-transform"
        >
            {/* テキスト（画像の上に表示） */}
            <span className="mb-0 text-lg md:text-base font-bold text-black drop-shadow">
                Top
            </span>

            {/* 画像 */}
            <img
                src={emimaru_flying}
                alt="Top"
                className="w-full h-full object-contain"
            />
        </button>
    );
}
